import initialState from './initialState';
import { FETCH_APPROVALS, RECEIVE_APPROVALS } from '../actions/actionTypes';

export default function approvalsReducer(state = initialState.approvals, action) {
	let newState = {};
	switch (action.type) {
		case FETCH_APPROVALS:
			return { ...state, fetching: true };
		case RECEIVE_APPROVALS:
			newState.items = action.approvals.items;
			newState.pagination = action.approvals.pagination;
			newState.pagination.pageSizeOptions = state.pagination.pageSizeOptions;
			newState.search = action.approvals.search;
			newState.fetching = false;
			return newState;
		default:
			return state;
	}
}